import React, { useRef, useEffect, useState, useCallback } from 'react';
import { GET_SUGGESTIONS_ENDPOINT } from '@helpers/api';
import { useApi } from '@hooks/useApi';
import SvgSubmit from '@img/icons/search-submit.svg';
import { useDebounce } from 'react-use';
import S from './SearchOverlay.styles';
import SvgSearchClose from '@img/icons/search-close.svg';
const SearchOverlay = ({ initialSearchTerm = '', isActive, placeholder = 'Search James Fisher', searchUrl, suggestions, onSearchToggle, }) => {
    // Store ref to input element.
    const refInput = useRef(null);
    // Auto-focus search input when overlay is opened.
    useEffect(() => {
        if (isActive) {
            refInput.current?.focus();
        }
    }, [isActive]);
    // Store raw value for input field.
    const [searchTermRaw, setSearchTermRaw] = useState(initialSearchTerm);
    // Store debounced value for suggestion search.
    const [searchTermDebounced, setSearchTermDebounced] = useState(initialSearchTerm);
    // Fetch suggestions for debounced search term.
    const url = `${GET_SUGGESTIONS_ENDPOINT}?searchTerm=${searchTermDebounced}`;
    const { clear, data: typeahead } = useApi({
        url,
        validate: () => !!searchTermDebounced,
    });
    // Update debounced value when raw value stops changing.
    useDebounce(() => {
        setSearchTermDebounced(searchTermRaw);
        if (!searchTermRaw) {
            clear();
        }
    }, 400, [searchTermRaw]);
    // Determine suggestions to be displayed, and whether they're typeahead or not.
    const suggestionsToShow = typeahead ?? suggestions ?? [];
    const suggestionsAreTypehead = !!typeahead;
    const handleSearchChange = useCallback((event) => {
        setSearchTermRaw(event.target.value);
    }, []);
    return (React.createElement(S.Container, { "data-s-active": isActive, "aria-hidden": !isActive },
        React.createElement(S.Inner, null,
            React.createElement(S.FieldWrapper, { action: searchUrl, method: "GET" },
                React.createElement(S.Input, { ref: refInput, id: "search-overlay-term", name: "searchTerm", placeholder: placeholder, tabIndex: isActive ? 0 : -1, type: "search", value: searchTermRaw, onChange: handleSearchChange }),
                React.createElement(S.Submit, { "aria-label": "Search", tabIndex: isActive ? 0 : -1, type: "submit" },
                    React.createElement(SvgSubmit, null))),
            suggestionsToShow.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(S.SuggestionTitle, null, suggestionsAreTypehead ? 'Suggestions' : 'Popular Items'),
                React.createElement(S.SuggestionList, null, suggestionsToShow.map((item) => (React.createElement(S.SuggestionItem, { key: item.id },
                    React.createElement(S.SuggestionLink, { href: item.url ?? `${searchUrl}?searchTerm=${item.text}`, tabIndex: isActive ? 0 : -1 }, item.text)))))))),
        React.createElement(S.CloseButton, { onClick: (event) => {
                event.preventDefault();
                onSearchToggle();
            }, "aria-label": "Close Search", "aria-expanded": "true", title: "Close Search" },
            React.createElement(SvgSearchClose, { "aria-hidden": "true" }))));
};
export default SearchOverlay;
